import React from 'react';
import { Typography } from 'antd';
import styles from './index.module.scss';

const { Title, Text } = Typography;

const TitleBlock = ({ icon, title, description }) => {
  return (
    <div className={styles.root}>
      <div className={styles.iconWrap}>{icon}</div>
      <div className={styles.contentWrap}>
        <Title level={2} className={styles.title}>
          {title}
        </Title>
        {description && <Text>{description}</Text>}
      </div>
    </div>
  );
};

export default TitleBlock;
